import { render, staticRenderFns } from "./SearchSortFilter.vue?vue&type=template&id=61d7aa4c&"
import script from "./SearchSortFilter.vue?vue&type=script&lang=js&"
export * from "./SearchSortFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports